import {
  FormPageAuthInputItemTextFree,
  FormPageInputItemTextAdditionalText,
  FormPageInputItemTextMultiLine,
  FormPageInputItemTextName,
  FormPageInputItemTextSingleLine,
  FormPageInputItemTextTel,
  FormPageInputItemTextZipCode,
  FormPageInputItemTextZipCodeWithoutHyphen,
  TextPropertyName,
  TextPropertyTel,
  TextPropertyZipCode,
} from 'shared';
import { buildStringWithDelimiter, isAllStringsFalsy } from './shared';

const convertSingleLine = (text?: string): string | undefined => {
  if (text === '') {
    return undefined;
  }
  return text;
};

export const convertTextSingleLine = (
  value: FormPageInputItemTextSingleLine
): string | undefined => {
  return convertSingleLine(value.text);
};

export const convertTextAdditionalText = (
  value: FormPageInputItemTextAdditionalText
): string | undefined => {
  return convertSingleLine(value.text);
};

export const convertTextName = (
  value: FormPageInputItemTextName,
  property: TextPropertyName
): string | undefined => {
  const { firstName, lastName } = value;
  if (isAllStringsFalsy(firstName, lastName)) {
    return undefined;
  }
  const { delimiter } = property.inputFormat;
  return buildStringWithDelimiter([firstName, lastName], delimiter);
};

export const convertTextTel = (
  value: FormPageInputItemTextTel,
  property: TextPropertyTel
): string | undefined => {
  const { first, second, third } = value;
  if (isAllStringsFalsy(first, second, third)) {
    return undefined;
  }
  const { delimiter } = property.inputFormat;
  return buildStringWithDelimiter([first, second, third], delimiter);
};

export const convertTextZipCode = (
  value: FormPageInputItemTextZipCode,
  property: TextPropertyZipCode
): string | undefined => {
  const { first, second } = value;
  if (isAllStringsFalsy(first, second)) {
    return undefined;
  }
  const { delimiter } = property.inputFormat;
  return buildStringWithDelimiter([first, second], delimiter);
};

export const convertTextZipCodeWithoutHyphen = (
  value: FormPageInputItemTextZipCodeWithoutHyphen
): string | undefined => {
  return convertSingleLine(value.zipCode);
};

export const convertTextMultiLine = (
  value: FormPageInputItemTextMultiLine
): string | undefined => {
  return convertSingleLine(value.text);
};

export const convertAuthTextFree = (
  value: FormPageAuthInputItemTextFree
): string | undefined => {
  return convertSingleLine(value.text);
};
